module.exports = __webpack_public_path__ + "static/img/1.b19c200.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/7/1/1.png
// module id = 5Krv
// module chunks = 0